/**
 * Curated brand-colour presets shown on the Branding page. Each tenant
 * can pick one of these or type their own #RRGGBB. The first entry is
 * the Bokapsys default (also rendered as "Reset to default" elsewhere).
 */
export type BrandPreset = { name: string; hex: string }

export const BRAND_PRESETS: BrandPreset[] = [
  { name: 'Bokapsys Blue',  hex: '#0072ce' },
  { name: 'Royal Indigo',   hex: '#4f46e5' },
  { name: 'Plum Violet',    hex: '#7c3aed' },
  { name: 'Magenta',        hex: '#db2777' },
  { name: 'Coral Red',      hex: '#e11d48' },
  { name: 'Sunset Orange',  hex: '#ea580c' },
  { name: 'Amber',          hex: '#d97706' },
  { name: 'Forest Emerald', hex: '#15803d' },
  { name: 'Teal',           hex: '#0d9488' },
  { name: 'Sky',            hex: '#0284c7' },
  { name: 'Slate',          hex: '#475569' },
  { name: 'Graphite',       hex: '#1f2937' },
]

export const DEFAULT_BRAND_HEX = BRAND_PRESETS[0].hex
